<div class="app-container">
  @if (showLoader()) {
  <app-loader [duration]="5000" (completed)="onLoaderComplete()"> </app-loader>
  }

  <main class="main-content">
    <router-outlet></router-outlet>
  </main>
</div>
